import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ModificationEmployee  {
    _originalTypeClassName = "zERP.BO.ModificationEmployee";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ModificationEmployee.translate = translateService;
}
this.lstModificationValues = [];
this.Id = null;
this.EffectiveFrom = null;
this.State = null;
this.Justification = null;
this.Published = null;
this.Announcment = null;
this.CancelationDate = null;
this.CancelationReason = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
EffectiveFrom:any;
State:any;
Justification:any;
Published:any;
Announcment:any;
CancelationDate:any;
CancelationReason:any;
EmployeeContract:any;
Type:any;
lstModificationValues:any;
static setEmployeeContract = ($this, value) => {
var oldValue = $this.EmployeeContract;
$this.EmployeeContract = value;
if (value != null) {
}
}
static setType = ($this, value) => {
var oldValue = $this.Type;
$this.Type = value;
if (value != null) {
}
}
static setlstModificationValues = ($this, items) => {
                if (items == null) items = [];
                if ($this.lstModificationValues == null) $this.lstModificationValues = [];

                const copyItems = Common.cloneObject(items);

                while ($this.lstModificationValues.length > 0) {
                    Domain.ModificationEmployee.removelstModificationValues($this, $this.lstModificationValues[0]);
                }

                Domain.ModificationEmployee.addManylstModificationValues($this, copyItems);
            }
static addManylstModificationValues = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ModificationEmployee.addlstModificationValues($this, items[i]);
                }
            }
static addlstModificationValues = ($this, item) => {
                if ($this.lstModificationValues == null) $this.lstModificationValues = [];
                if (item == null || $this.lstModificationValues.indexOf(item) > -1) return;
                $this.lstModificationValues.push(item);
}
static addRangelstModificationValues = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ModificationEmployee.addlstModificationValues($this, item));
            }
static removelstModificationValues = ($this, item) => {
                if ($this == null || $this.lstModificationValues == null || $this.lstModificationValues.indexOf(item) === -1) return;
                var _index = $this.lstModificationValues.indexOf(item);
                $this.lstModificationValues.splice(_index, 1);
}
static clearlstModificationValues = ($this) => { $this.lstModificationValues = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}